// #region Types
export type TraceId = {
  version: string;
  timestamp: string;
  identifier: string;
  toString(): string;
};
// #endregion

// #region Utility Functions
const getTimestamp = (): string => {
  const timestamp = Math.floor(Date.now() / 1000);
  return timestamp.toString(16);
};

const getIdentifier = (size: number): string => {
  return Array.from(
    window.crypto.getRandomValues(new Uint8Array(size)),
    (byte) => ('0' + byte.toString(16)).slice(-2)
  ).join('');
};

const createTraceId = (
  version: string,
  timestamp: string,
  identifier: string
): TraceId => ({
  version,
  timestamp,
  identifier,
  toString: () => `${version}-${timestamp}-${identifier}`,
});
// #endregion

// #region Public API
export const generateTraceId = (): TraceId => {
  const version = '2';
  const timestamp = getTimestamp();
  const identifier = getIdentifier(12);

  return createTraceId(version, timestamp, identifier);
};
// #endregion
